/**
 * @file 教师上课端路由装配
 * 页面级权限用 PermissionRoute 二次兜底：菜单隐藏只是体验，直接输 URL 也必须被拦到 /403。
 */

import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  ChangePasswordPage,
  Dashboard,
  ForbiddenPage,
  LoginPage,
  NotFoundPage,
  PermissionRoute,
  ProtectedLayout,
  SoonPage,
  useAuthBootstrap,
  useRuntime,
} from '@lexiloop/shared';
import { NAV } from './nav';
import { DASH_CARDS } from './dashboard';

/** 端名：登录页、外壳、占位页共用。 */
const END_NAME = '教师上课端';

/**
 * @what 教师端根组件：登录 / 工作台 / 403 / 404
 * @return JSX
 */
export function App() {
  const runtime = useRuntime();
  useAuthBootstrap();

  useEffect(() => {
  }, [runtime]);

  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginPage endName={END_NAME} subtitle="用工号登录。首次登录要先改初始密码，再过一次短信验证。" accountHint="工号或手机号" />}
      />
      <Route element={<ProtectedLayout endName={END_NAME} nav={NAV} />}>
        <Route path="403" element={<ForbiddenPage />} />
        <Route path="404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route index element={<Dashboard title="教师工作台" subtitle="今日课程、待办与本人销课" cards={DASH_CARDS} />} />
        <Route path="password" element={<ChangePasswordPage />} />
        <Route
          path="students"
          element={
            <PermissionRoute permission="user:read">
              <SoonPage moduleName="我的学员" />
            </PermissionRoute>
          }
        />
        <Route
          path="schedule"
          element={
            <PermissionRoute permission="schedule:read">
              <SoonPage moduleName="我的课表" />
            </PermissionRoute>
          }
        />
      </Route>
    </Routes>
  );
}
